module.exports = __webpack_public_path__ + "media/images/ninestars/team/team-1-cb99efe5d21e9e6b1f98ea15b2fe218d.jpeg";